import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { dataHas } from '../../common/ambient'
import {
  FormattedDataPoint
} from './'

export default class WaterPhWidget extends PureComponent {
  static propTypes = {
    currentDevice: PropTypes.object
  };

  render() {
    const { currentDevice } = this.props
    const { lastData } = currentDevice
    const data = lastData
    let widget = <div className="waterph-widget hidden" />
    const currentDataHas = dataHas(data)
    if(currentDataHas('watermeasph')) {
      widget =
      <div className="med-number waterph-widget">
        <FormattedDataPoint type={'watermeasph'} row={lastData} />
      </div>
    }
    return widget
  }
};
WaterPhWidget.displayName = 'WaterPhWidget'
